import React from "react";

// Commenter's own domains. White-label tenants run on their own hostnames and
// must not see Commenter pricing, billing or platform-only routes.
const FIRST_PARTY_HOSTS = [
  "app.commenter.ai",
  "www.commenter.ai",
  "commenter.ai",
  "localhost",
  "127.0.0.1",
];

export const isFirstPartyHost = () => {
  if (typeof window === "undefined") return false;
  return FIRST_PARTY_HOSTS.includes(window.location.hostname);
};

/**
 * Conditionally renders JSX only on Commenter's own domains.
 * @param {React.ReactNode} jsx
 * @returns
 */
export const getHostNameConfig = (jsx) => {
  return isFirstPartyHost() ? jsx : null;
};
